import { GET_PLAN_DETAILS, GET_PLANS, UPDATE_PLAN } from "helpers/url_helper";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { put , get, post } from "helpers/api_helper";

export const getPlans = createAsyncThunk(GET_PLANS, async (payload) => {
  const response = await post(GET_PLANS, payload);
  return response;
});
export const getPlanDetails = createAsyncThunk(
  GET_PLAN_DETAILS,
  async (payload) => {
    const response = await post(`${GET_PLAN_DETAILS}`, payload);
    return response;
  }
);

export const updatePlan = createAsyncThunk(UPDATE_PLAN, async (payload) => {
  const response = await put(UPDATE_PLAN, payload);
  return response;
});